import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ icon, label, value, change, trend, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10',
    secondary: 'bg-secondary/10',
    accent: 'bg-accent/10',
    success: 'bg-success/10'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-1 transition-shadow">
      <div className="flex items-center justify-between mb-3">
        <div className={`w-12 h-12 ${colorClasses?.[color]} rounded-lg flex items-center justify-center`}>
          <Icon name={icon} size={24} color={`var(--color-${color})`} />
        </div>
        {change && (
          <div className={`flex items-center gap-1 text-sm font-medium ${
            trend === 'up' ? 'text-success' : trend === 'down' ? 'text-error' : 'text-muted-foreground'
          }`}>
            {trend === 'up' && <Icon name="TrendingUp" size={16} />}
            {trend === 'down' && <Icon name="TrendingDown" size={16} />}
            <span>{change}</span>
          </div>
        )}
      </div>
      <p className="text-3xl font-bold text-foreground mb-1">{value}</p>
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
};

export default KPICard;